import React from 'react';
import { MissedCallChip } from '../components/messaging/MissedCallChip';

/**
 * Dev-only preview page for the MissedCallChip. Renders every
 * combination of status × viewer-role so we can visually verify the
 * copy variants without needing an end-to-end call. Reachable only
 * via /dev/missed-call-chip.
 */
export default function MissedCallChipPreview() {
  const now = new Date().toISOString();
  const variants = [
    { label: 'Callee side · missed', status: 'missed', senderId: 'caller-1', viewerId: 'callee-1' },
    { label: 'Callee side · no_answer', status: 'no_answer', senderId: 'caller-1', viewerId: 'callee-1' },
    { label: 'Caller side · no answer', status: 'no_answer', senderId: 'caller-1', viewerId: 'caller-1' },
    { label: 'Caller side · declined', status: 'declined', senderId: 'callee-1', viewerId: 'caller-1' },
    { label: 'Callee side · you declined', status: 'declined', senderId: 'callee-1', viewerId: 'callee-1' },
    { label: 'Caller side · no answer (call-back blocked)', status: 'no_answer', senderId: 'caller-1', viewerId: 'caller-1', blocked: true },
  ];
  return (
    <div style={{ minHeight: '100vh', background: 'var(--app-bg, #F8F5FF)', padding: '32px 16px' }}>
      <h1 style={{ fontFamily: "'Inria Serif', serif", fontSize: 24, marginBottom: 24, textAlign: 'center' }}>MissedCallChip · preview</h1>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 22, maxWidth: 420, margin: '0 auto' }}>
        {variants.map((v, i) => (
          <div key={i} style={{ borderTop: '1px dashed rgba(0,0,0,0.14)', paddingTop: 14 }}>
            <p style={{ margin: '0 0 6px', fontFamily: "'Inria Serif', serif", fontSize: 12, color: 'var(--text-2, #666)' }}>{v.label}</p>
            <MissedCallChip
              message={{ id: `m-${i}`, sender_id: v.senderId, message_type: 'call_event', metadata: { status: v.status, call_id: `call-${i}` }, created_at: now }}
              viewerId={v.viewerId}
              canCallBack={!v.blocked}
              onCallBack={() => alert(`Call back triggered (${v.status})`)}
              dataTestId={`preview-missed-chip-${i}`}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
